var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDamagedDevice = function SvgDamagedDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 60,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50 9H30a7 7 0 0 0-7 7v48a7 7 0 0 0 7 7h20a7 7 0 0 0 7-7V16a7 7 0 0 0-7-7m5 55a5 5 0 0 1-5 5H30a5 5 0 0 1-5-5V16a5 5 0 0 1 5-5h3.61L30 16.55a1 1 0 0 0 0 1.09l3.83 5.74-1.45 7.7a1 1 0 0 0 .8 1.17h.19a1 1 0 0 0 1-.82l1.52-8.1a1 1 0 0 0-.15-.74l-3.69-5.53L36 11h14a5 5 0 0 1 5 5Z"
  })));
};
export default SvgDamagedDevice;